const formatDate = date => {
   let _date = date.toISOString().slice(0, 4) + '-' +
    date.toISOString().slice(5, 7) + '-' +
    date.toISOString().slice(8, 10);
    return _date;
}
export default formatDate;